import axios from 'axios';
import {getCurrentSession} from '../../endpoints/amplify/auth';
import { API_PUBLIC_HOST } from '../../_constant/urlconstants';
import {Error} from '../notification/notification';
import api from '@/apis/request';

export const  getBrandList =(brandName)=>{
 return axios.get(API_PUBLIC_HOST + '/lookup/brands?group='+brandName)
  .then(response => {
    return response
}).then((resp)=> {
  return resp?.data.response
}).catch(error => {
     
  });
}

export const  saveListItem =(data)=>{
  return new Promise((resolve, reject) => {
    getCurrentSession((success, user, jwtToken) => {
      const url = `${API_PUBLIC_HOST}/listing/saveListing`
      axios({
        method: "POST",
        url: url,
        data: data,
        headers: {
          Accept: "application/json",
        "Content-Type": "application/json",
          Authorization: jwtToken,
        },
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          if (error.response && error.response.status === 500) {
            console.log("Server error:", error.response.data);
            Error("Something went wrong. Please try again later.");
          } else if (error.message === "Network Error") {
            console.log("Network error:", error.message);
            Error("There is a problem with your internet connection.");
            window.location.href = '/';
          } else {
            reject(error);
          }
        });
    });
  });
}

export const saveAddress = (addNewAddress) => {
  
  return new Promise((resolve, reject) => {
    getCurrentSession((success, user, jwtToken) => {
      const url = `${API_PUBLIC_HOST}/user/addAddress`;
      axios({
        method: "POST",
        url: url,
        data: JSON.stringify(addNewAddress),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: jwtToken,
        },
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          if (error.response && error.response.status === 500) {
            console.log("Server error:", error.response.data);
            Error("Something went wrong. Please try again later.");
          } else if (error.message === "Network Error") {
            console.log("Network error:", error.message);
            Error("There is a problem with your internet connection.");
            window.location.href = '/';
          } else {
            reject(error);
          }
        });
    });
  });
};

export const getIdListData = (id) => {
  return new Promise((resolve, reject) => {
    getCurrentSession((success, user, jwtToken) => {
      const url = `${API_PUBLIC_HOST}/listing/viewListing?`;
      var URL = url + "listId=" + id;
      axios({
        method: "get",
        url: URL,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: jwtToken,
        },
      })
        .then((response) => {
          resolve(response?.data?.response);
        })
        .catch((error) => {
          if (error.response && error.response.status === 500) {
            console.log("Server error:", error.response.data);
            Error("Something went wrong. Please try again later.");
          } else if (error.message === "Network Error") {
            console.log("Network error:", error.message);
            Error("There is a problem with your internet connection.");
          } else {
            reject(error);
          }
        });
    });
  });
};

export const getOfferCategories = () => {
  return axios
    .get(API_PUBLIC_HOST + "/lookup/category")
    .then((response) => {
      return response;
    })
    .then((resp) => {
      return resp?.data.response;
    })
    .catch(() => {});
};


export const getFiltersData = async (catID, values) => {
  try {
    const { success, user, jwtToken } = {} //await getCurrentSession();
    const url = `${API_PUBLIC_HOST}/listing/searchListing?categoryId=${catID}`;
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: jwtToken,
    };  
    const response = await axios.post(url, { ...values }, { headers });
    return response.data.response;
  } catch (error) {
    if (error.response && error.response.status === 500) {
      console.log("Server error:", error.response.data);
      throw new Error("Something went wrong. Please try again later.");
    } else if (error.message === "Network Error") {
      console.log("Network error:", error.message);
      throw new Error("There is a problem with your internet connection.");
    } else {
      throw error;
    }
  }
};

export const getIdAddZOneData = (id) => {
  return new Promise((resolve, reject) => {
    getCurrentSession((success, user, jwtToken) => {
      const url = `${API_PUBLIC_HOST}/product-ad/viewProductAd?`;
      var URL = url + "ProductAdId=" + id;
      axios({
        method: "get",
        url: URL,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: jwtToken,
        },
      })
        .then((response) => {
          resolve(response?.data?.response);
        })
        .catch((error) => {
          if (error.response && error.response.status === 500) {
            console.log("Server error:", error.response.data);
            Error("Something went wrong. Please try again later.");
          } else if (error.message === "Network Error") {
            console.log("Network error:", error.message);
            Error("There is a problem with your internet connection.");
          } else {
            reject(error);
          }
        });
    });
  });
};

export const updateUser = (userInfo) => {
  return new Promise((resolve, reject) => {
    const url = `${API_PUBLIC_HOST}/user/updateUser`;
    api.post(url, JSON.stringify(userInfo))
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (error.response && error.response.status === 500) {
          console.log("Server error:", error.response.data);
          Error("Something went wrong. Please try again later.");
        } else if (error.message === "Network Error") {
          console.log("Network error:", error.message);
          Error("There is a problem with your internet connection.");
          window.location.href = '/';
        } else {
          reject(error);
        }
      });
  });
};


export const addUserAccess = (userInfo) => {
  return new Promise((resolve, reject) => {
    const url = `${API_PUBLIC_HOST}/user/addOrGetUserAccess`;
    api.post(url, JSON.stringify(userInfo))
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (error.response && error.response.status === 500) {
          console.log("Server error:", error.response.data);
          if(error.response?.data != ''){
            return Error(error.response?.data.message);
          }
          Error("Something went wrong. Please try again later.");
        } else if (error.message === "Network Error") {
          console.log("Network error:", error.message);
          Error("There is a problem with your internet connection.");
          window.location.href = '/';
        } else {
          reject(error);
        }
      });
  });
};

export const sendAssigneeOtp = (name,email,phone,categoryId) => {
  return new Promise((resolve, reject) => {
    
    const url = `${API_PUBLIC_HOST}/otp/generateAssigneeOTP`;
    var URL = url + "?assigneeName="+name+"&categoryId="+categoryId+ "&email="+email+"&mobileNumber="+phone;
    api.put(URL)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (error.response && error.response.status === 500) {
          console.log("Server error:", error.response.data);
          Error("Something went wrong. Please try again later.");
        } else if (error.message === "Network Error") {
          console.log("Network error:", error.message);
          Error("There is a problem with your internet connection.");
        } else {
          reject(error);
        }
      });
    
  });
};

export const verifySentAssigneeOtp = (otp, phone) => {
  return new Promise((resolve, reject) => {
    const url = `${API_PUBLIC_HOST}/otp/validateOTP`;
    var URL = url + "?otp="+otp+"&userId="+phone;
    api.put(URL)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (error.response && error.response.status === 500) {
          console.log("Server error:", error.response.message);
          Error("Something went wrong. Please try again later.");
        } else if (error.message === "Network Error") {
          console.log("Network error:", error.message);
          Error("There is a problem with your internet connection.");
        } else {
          reject(error);
        }
      });
  });
};